var exports = {
  "i": "xaee3c4fa--9fd660--wrapper",
};

module.exports = exports;
